import ErrorFallback from "../common/ErrorFallback";
import AddSolutionForm from "./add-solution";
import SolutionListContainer from "./solution-list";
import { ErrorBoundary } from "react-error-boundary";
import SolutionDetails from "./solution-details";
import { Route, Routes } from "react-router";

function SolutionContainer() {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Routes>
          <Route path="/" element={<SolutionListContainer />} />
          <Route path="/new" element={<AddSolutionForm />} />
          <Route path="/view/:id" element={<SolutionDetails />} />
          <Route path="/*" element={<SolutionListContainer />} />
        </Routes>
      </ErrorBoundary>
    </>
  );
}

export default SolutionContainer;
